<template>
	<v-container>
		<v-layout v-if="!metamaskInstalled" column>
			<v-flex>
				<span> 
					It seems that you do not have Metamask installed, in order to use your wallet you need to use this addon!
				</span>
			</v-flex>
			<v-flex>
				<a
					class="meta-button"
					href="https://metamask.io/"
					target="_blank"
				>
					<img
						class="meta-button"
						src="@/assets/download-metamask.png"
						width="50%"
					>
				</a>
			</v-flex>
			<v-flex>
				<!-- <v-btn @click="$emit('clickReloadStatus')">
					Refresh
				</v-btn> -->
			</v-flex>
		</v-layout>
		<v-layout v-else>
			<v-layout 
				column 
				wrap
			>
				<v-flex> 
					<h3> 
						We've detected your metamask wallet
					</h3>
				</v-flex>
				<v-flex>
					<v-chip color="success" text-color="white">
						<v-avatar>
							<v-icon small>
								fas fa-wallet
							</v-icon>
						</v-avatar>
						{{ defaultAccount }}
					</v-chip>
				</v-flex>
				<v-flex> 
					<h2> 
						Do you confirm that you want to use this address?
					</h2>
				</v-flex>
			</v-layout>
		</v-layout>
	</v-container>
</template>


<script>

export default {
	props: ['defaultAccount', 'metamaskInstalled'],

	data () {
		return {
			alertLabel: '',
			valid: true
		}
	},

	computed: {
		progress () {
			return Math.min (100, this.credentials.password.length * 10)
		},
		color () {
			return ['error', 'warning', 'success'][Math.floor (this.progress / 40)]
		}
	},

	watch: {
	
	},

	methods: {

  
	},

}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: $primary;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
}

.sign-button:hover {
	text-decoration: underline;
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

.meta-button {
	cursor: pointer;
	&hover {

	
	}
}

</style>
